import { useQuery } from '@tanstack/react-query';
import { newsroomApi } from '@/services/newsroomApi';
import { useAuth } from './useAuth';

// Per-org analog of useFeatureFlags — gates an opt-in add-on (e.g. 'newsroom')
// that's enabled per-organization rather than platform-wide. Currently only
// backed by the newsroom feature-status endpoint; extend the lookup map if
// more per-org add-ons are introduced.
const FEATURE_STATUS_QUERIES: Record<string, () => Promise<{ enabled: boolean }>> = {
  newsroom: () => newsroomApi.getFeatureStatus(),
};

export const useOrgFeature = (feature: string) => {
  const { isAuthenticated } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['org-feature', feature],
    queryFn: () => FEATURE_STATUS_QUERIES[feature]?.() ?? Promise.resolve({ enabled: false }),
    enabled: isAuthenticated,
    staleTime: 60 * 1000,
  });

  // Fail closed while loading/on error — opt-in add-ons stay hidden until
  // confirmed enabled for this organization.
  return { isEnabled: data?.enabled ?? false, isLoading };
};
